export const ABUSE_TEMPLATES = [
	{
		group: "Under development",
		items: [
			{
				name: "“One Human, One Trial”",
				desc: "Prevent trial cycling via IP/device/email similarity + email alias fuzzing.",
			},
			{
				name: "“Fake Viral Growth Prevention”",
				desc: "Stop self-referrals, circular chains, and reward farming.",
			},
			{
				name: "“Refund Abuser Flag”",
				desc: "Detect users with multiple chargebacks or fast refund requests.",
			},
			{
				name: "“Account Farm Shield”",
				desc: "Flag bulk account creation patterns from clustered IPs/devices.",
			},
			{
				name: "“Stealth Scraper Deterrent”",
				desc: "Use mouse movement checks, JS traps, and hidden honeypots.",
			},
			{
				name: "“Disposable Email Throttle”",
				desc: "Block or limit users from known disposable domains; allow upgrade path on verification.",
			},
		],
	},
];
